import React from 'react';

export const Cartesian3DAxes = ({ centerX, centerY, size = 100, strokeWidth = 1 }) => {
  // Calculate 3D axis endpoints for isometric-like view
  const xEnd = { x: centerX + size, y: centerY };
  const yEnd = { x: centerX - size * 0.5, y: centerY - size * 0.866 }; // 60 degrees up-left
  const zEnd = { x: centerX, y: centerY - size }; // straight up

  return (
    <g>
      {/* X-axis (red) */}
      <line 
        x1={centerX} 
        y1={centerY} 
        x2={xEnd.x} 
        y2={xEnd.y} 
        stroke="red" 
        strokeWidth={strokeWidth}
        markerEnd="url(#arrowX)"
      />
      <text x={xEnd.x + 10} y={xEnd.y + 5} fontSize="14" fill="red" fontWeight="bold">X</text>
      
      {/* Y-axis (green) */}
      <line 
        x1={centerX} 
        y1={centerY} 
        x2={yEnd.x} 
        y2={yEnd.y} 
        stroke="green" 
        strokeWidth={strokeWidth}
        markerEnd="url(#arrowY)"
      />
      <text x={yEnd.x - 15} y={yEnd.y - 5} fontSize="14" fill="green" fontWeight="bold">Y</text>
      
      {/* Z-axis (blue) */}
      <line 
        x1={centerX} 
        y1={centerY} 
        x2={zEnd.x} 
        y2={zEnd.y} 
        stroke="blue" 
        strokeWidth={strokeWidth}
        markerEnd="url(#arrowZ)"
      />
      <text x={zEnd.x + 10} y={zEnd.y - 5} fontSize="14" fill="blue" fontWeight="bold">Z</text>
      
      {/* Arrow markers */}
      <defs>
        <marker id="arrowX" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto" markerUnits="strokeWidth">
          <path d="M0,0 L0,6 L9,3 z" fill="red" />
        </marker>
        <marker id="arrowY" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto" markerUnits="strokeWidth">
          <path d="M0,0 L0,6 L9,3 z" fill="green" />
        </marker>
        <marker id="arrowZ" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto" markerUnits="strokeWidth">
          <path d="M0,0 L0,6 L9,3 z" fill="blue" />
        </marker>
      </defs>
    </g>
  );
};

